import {
    FieldInCard,
} from 'app/types/form.types'

import {
    FeedbackFormData,
} from '../components/UploadFeedback/UploadFeedback.types'
import {
    UpdateFormData,
} from './BatchUpdate.types'

export const selectedRecordsField: FieldInCard<keyof UpdateFormData> = {
    name: 'selectedRecords',
    componentName: 'InputSingleline',
    labelKey: 'SELECTED_RECORDS',
    disabled: true,
}

export const updatedRecordsField: FieldInCard<keyof FeedbackFormData> = {
    name: 'updatedRecords',
    componentName: 'InputSingleline',
    labelKey: 'UPDATED_RECORDS',
    disabled: true,
}
